<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('abstract.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="card">
                <div class="card-title-line">
                    <div class="card-title">{{ $t('dailyActive.weekTitle') }}</div>
                </div>
                <div class="card-box">
                    <div style="height: 1px"></div>
                    <div class="target-desc" v-if="type == 0">{{ $t('dailyActive.weekDesc0') }}{{ format(weekDataAll) }}{{
                            $t('dailyActive.weekDesc1')
                        }}{{ stepLaps }}{{ $t('dailyActive.weekDesc2') }}
                    </div>
                    <div class="target-desc" v-if="type == 1">{{ $t('dailyActive.weekCalDesc0') }}{{
                            format(weekDataAll)
                        }}<span v-if="weekDataAll>0">{{
                                $t('dailyActive.weekCalDesc1')
                            }}</span><span
                            v-if="bigFood.num > 0">{{ 100 * bigFood.num + 'g ' + bigFood[$i18n.locale] }}</span><span
                            v-if="showAnd">{{ $t('dailyActive.and') }}</span><span
                            v-if="smallFood != 0">100g {{ smallFood[$i18n.locale] }}</span>{{ $t('dailyActive.stepToDC2') }}
                    </div>
                    <div class="separate"></div>
                    <div class="ratio-title"  :class="{'ratio-title-step':type == 0, 'ratio-title-cal':type == 1, 'ratio-title-strength':type == 2}">{{ $t('dailyActive.weekDay') }}</div>
                    <div class="day-average-box">
                        <div class="last-chart" id="last-chart">
                        </div>
                        <div class="this-chart" id="this-chart">
                        </div>
                    </div>
                    <div v-if="type == 0">
                        <div class="day-desc" v-if="weekSymbol !== 2">{{
                                $t('dailyActive.weekDayDesc0')
                            }}<span v-if="weekSymbol == 0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                                v-if="weekSymbol == 1">{{
                                    $t('dailyActive.weekDayReduce')
                                }}</span>{{ format(Math.abs(weekAvgData - lastWeekAvgData)) }}{{
                                $t('dailyActive.weekDayDesc1')
                            }}
                        </div>
                        <div class="day-desc" v-else>{{
                                $t('dailyActive.weekDayDesc2')
                            }}
                        </div>
                    </div>
                    <div v-if="type == 1">
                        <div class="day-desc" v-if="weekSymbol !== 2">{{
                                $t('dailyActive.weekDayCalDesc0')
                            }}<span v-if="weekSymbol == 0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                                v-if="weekSymbol == 1">{{
                                    $t('dailyActive.weekDayReduce')
                                }}</span>{{ format(Math.abs(weekAvgData - lastWeekAvgData)) }}{{
                                $t('dailyActive.weekDayCalDesc1')
                            }}
                        </div>
                        <div class="day-desc" v-else>{{
                                $t('dailyActive.weekDayCalDesc2')
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-title-line"  :class="{'card-title-line-en':$i18n.locale !=='zh'}">
                    <div class="card-title">{{ $t('dailyActive.monthTitle') }}</div>
                </div>
                <div class="card-box">
                    <div class="separate"></div>
                    <div class="ratio-title"  :class="{'ratio-title-step':type == 0, 'ratio-title-cal':type == 1, 'ratio-title-strength':type == 2}" >{{ $t('dailyActive.weekDay') }}</div>
                    <div class="target-desc" v-if="type == 0">{{ $t('dailyActive.monthDayDesc0') }}{{ format(monthAvgData) }}<span v-if="monthSymbol !== 2">{{
                            $t('dailyActive.monthDayDesc1')
                        }}<span v-if="monthSymbol == 0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                            v-if="monthSymbol == 1">{{
                                $t('dailyActive.weekDayReduce')
                            }}</span>{{ format(Math.abs(monthAvgData - lastMonthAvgData)) }}{{ $t('dailyActive.weekDayDesc1') }}</span>
                        <span v-else>{{ $t('dailyActive.monthDayDesc3') }}</span>
                    </div>
                    <div class="target-desc" v-if="type == 1">{{ $t('dailyActive.monthCalDayDesc0') }}{{ format(monthAvgData) }}<span v-if="monthSymbol !== 2">{{
                            $t('dailyActive.monthCalDayDesc1')
                        }}<span v-if="monthSymbol == 0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                            v-if="monthSymbol == 1">{{
                                $t('dailyActive.weekDayReduce')
                            }}</span>{{ format(Math.abs(monthAvgData - lastMonthAvgData))}}{{ $t('dailyActive.monthCalDayDesc2') }}</span>
                        <span v-else>{{ $t('dailyActive.monthCalDayDesc3') }}</span>
                    </div>
                    <div class="target-desc" v-if="type == 2">{{ $t('dailyActive.monthSportStrengthDesc0') }}{{ format(monthAvgData) }}<span v-if="monthSymbol !== 2">{{
                            $t('dailyActive.monthSportStrengthDesc1')
                        }}<span v-if="monthSymbol == 0">{{ $t('dailyActive.weekDayAdd') }}</span><span
                            v-if="monthSymbol == 1">{{
                                $t('dailyActive.weekDayReduce')
                            }}</span>{{ format(Math.abs(monthAvgData - lastMonthAvgData))}}{{ $t('dailyActive.monthCalDayDesc2') }}</span>
                        <span v-else>{{ $t('dailyActive.monthSportStrengthDesc3') }}</span>
                    </div>
                    <div class="month-num">{{ format(monthAvgData) }}</div>
                    <div class="current-month"
                         :class="{'big-month' : monthSymbol == 0, 'step-color' : type == 0, 'cal-color' : type == 1, 'strength-color' : type == 2}">
                        <div class="current-month-text">{{ $t('dailyActive.monthThis') }}</div>
                    </div>
                    <div class="month-num">{{ format(lastMonthAvgData) }}</div>
                    <div class="last-month" :class="{'big-month' : monthSymbol == 1}">
                        <div class="last-month-text">{{ $t('dailyActive.monthLast') }}</div>
                    </div>
                    <div class="separate"></div>
                    <div class="ratio-title ratio-reach"  :class="{'ratio-title-step':type == 0, 'ratio-title-cal':type == 1, 'ratio-title-strength':type == 2}">{{ $t('dailyActive.monthReach') }}</div>
                    <div class="target-desc" v-if="daySymbol !== 2">{{ $t('dailyActive.monthReachDesc0') }}<span
                        v-if="daySymbol == 0">{{ $t('dailyActive.weekDayAdd') }}</span><span v-if="daySymbol == 1">{{
                            $t('dailyActive.weekDayReduce')
                        }}</span>{{ format(Math.abs(monthTargetDay - lastMonthTargetDay)) }}{{
                            $t('dailyActive.monthReachDesc1')
                        }}
                    </div>
                    <div class="target-desc" v-else>{{ $t('dailyActive.monthReachDesc2') }}</div>
                    <div class="reach-line">
                        <div class="reach-progress">
                            <van-progress :percentage="monthTargetDay/monthDay*100" :stroke-width="18*ratio"
                                          track-color="var(--text-color-22)"
                                          :color="type == 0 ? getSkin('--chart-color-8') : type == 1 ? getSkin('--chart-color-3') : getSkin('--chart-color-1')"/>
                            <div class="reach-text current-month-text">{{ $t('dailyActive.monthThis') }}</div>
                        </div>
                        <div class="reach-num"><span class="reach-num-text">{{ monthTargetDay }}</span> /{{ monthDay }}</div>
                    </div>
                    <div class="reach-line">
                        <div class="reach-progress">
                            <van-progress :percentage="lastMonthTargetDay/lastMonthDay*100" :stroke-width="18*ratio"
                                          track-color="var(--text-color-22)"
                                          color="#E3E6EC"/>
                            <div class="reach-text last-month-text">{{ $t('dailyActive.monthLast') }}</div>
                        </div>
                        <div class="reach-num"><span class="reach-num-text">{{ lastMonthTargetDay }}</span> /{{
                                lastMonthDay
                            }}
                        </div>
                    </div>
                    <div class="separate"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {format} from '@/utils/math'
import {getSkin} from "../../utils/comment";

export default {
    name: 'abstract',
    data() {
        return {
            theme: 'light',
            ratio: 1,
            type: 'step',
            userStep: 0, // ����
            stepLaps: '', // Ȧ
            weekDataAll: '',
            lastMonthAvgData: '',
            lastMonthDay: '31',
            lastMonthTargetDay: '',
            lastWeekAvgData: '',
            lastWeekData: [],
            monthAvgData: '',
            monthDataAll: '',
            monthDay: '',
            monthTargetDay: '',
            weekAvgData: '',
            weekData: [],
            weekSymbol: 0,// 0-多， 1- 少, 2-持平
            monthSymbol: 0,// 0-多， 1- 少, 2-持平
            daySymbol: 0,// 0-多， 1- 少, 2-持平
            bigFood: {
                zh: '五花肉',
                en: 'Pork Belly',
                ja: 'ストリーキーポーク',
                cal: 350,
                num: 1
            },
            smallFood: {},
            showAnd: false,
            foodCalories: [{
                zh: '冬瓜',
                en: 'winter melon',
                ja: '冬瓜',
                cal: '10'
            }, {
                zh: '丝瓜',
                en: 'sponge gourd',
                ja: 'ヘチマ',
                cal: '20'
            }, {
                zh: '杨梅',
                en: 'wax berry',
                ja: 'ヤマモモ',
                cal: '30'
            }, {
                zh: '梨',
                en: 'pear',
                ja: '梨',
                cal: '40'
            }, {
                zh: '苹果',
                en: 'apple',
                ja: 'リンゴ',
                cal: '50'
            }, {
                zh: '猕猴桃',
                en: 'kiwifruit',
                ja: 'キウイ',
                cal: '60'
            }, {
                zh: '荔枝',
                en: 'lychee',
                ja: 'ライチ',
                cal: '70'
            }, {
                zh: '螃蟹',
                en: 'crab',
                ja: 'カニ匹',
                cal: '80'
            }, {
                zh: '香蕉',
                en: 'banana',
                ja: 'バナナ',
                cal: '90'
            }, {
                zh: '凉皮',
                en: 'Cold Skin Noodles',
                ja: '凉皮',
                cal: '100'
            }, {
                zh: '猪肚',
                en: 'Pig\'s Stomach',
                ja: '豚の胃袋',
                cal: '110'
            }, {
                zh: '鸡腿',
                en: 'Chicken Leg',
                ja: '鶏の足',
                cal: '120'
            }, {
                zh: '紫薯',
                en: 'Purple Sweet Potato',
                ja: '紫いも',
                cal: '130'
            }, {
                zh: '青菜包',
                en: 'Green Vegetable Bun',
                ja: '野菜包み',
                cal: 140
            }, {
                zh: '榴莲',
                en: 'Durian',
                ja: 'ドリアン',
                cal: 150
            }, {
                zh: '鹌鹑蛋',
                en: 'Quail Egg',
                ja: 'うずらの卵',
                cal: 160
            }, {
                zh: '窝窝头',
                en: 'Wotou',
                ja: '窝窝头',
                cal: 170
            }, {
                zh: '鸭蛋',
                en: 'Duck Egg',
                ja: 'アヒルの卵',
                cal: 180
            }, {
                zh: '糯米鸡',
                en: 'Sticky Rice Chicken',
                ja: 'もち米鶏',
                cal: 190
            }, {
                zh: '炒面',
                en: 'Fried Noodles',
                ja: '焼きそば',
                cal: 200
            }, {
                zh: '烧卖',
                en: 'Siu Mai',
                ja: 'シュウマイ',
                cal: 210
            }, {
                zh: '馒头',
                en: 'Steamed Bun',
                ja: 'マントー',
                cal: 220
            }, {
                zh: '馄饨',
                en: 'Wonton',
                ja: 'ワンタン',
                cal: 230
            }, {
                zh: '小笼包',
                en: 'Soup Dumpling',
                ja: 'ショーロンポー',
                cal: 240
            }, {
                zh: '全麦面包',
                en: 'Whole Wheat Bread',
                ja: '全粒粉パン',
                cal: 250
            }, {
                zh: '烧饼',
                en: 'Chinese Sesame',
                ja: '焼餅',
                cal: 260
            }, {
                zh: '螺蛳粉',
                en: 'Luosifen',
                ja: '螺蛳粉',
                cal: 270
            }, {
                zh: '红肠',
                en: 'Red Sausage',
                ja: 'ソーセージ本',
                cal: 280
            }, {
                zh: '猪小排',
                en: 'Pork Spare Ribs',
                ja: '豚のステーキ',
                cal: 290
            }, {
                zh: '锅盔',
                en: 'Guokui',
                ja: 'Guokui',
                cal: 300
            }, {
                zh: '汤圆',
                en: 'Tangyuan',
                ja: 'Tangyuan',
                cal: 310
            }, {
                zh: '果丹皮',
                en: 'Guodanpi',
                ja: 'Guodanpi',
                cal: 320
            }, {
                zh: '牛腩',
                en: 'Beef Brisket',
                ja: 'サーロイン',
                cal: 330
            }, {
                zh: '葡萄干',
                en: 'Raisin',
                ja: 'レーズン',
                cal: 340
            }, {
                zh: '五花肉',
                en: 'Pork Belly',
                ja: 'ストリーキーポーク',
                cal: 350
            }],
        }
    },
    mounted() {
        this.theme = this.$route.query.theme;
        this.type = this.$route.query.type;
        this.userStep = this.$route.query.userStep;
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.getBasicReport();
    },
    methods: {
        back() {
            this.$router.back()
        },
        getSkin,
        getBasicReport() {
            let type;
            if (this.type == 0) {
                type = 'step';
            } else if (this.type == 1) {
                type = 'calorie';
            } else if (this.type == 2) {
                type = 'sportStrength';
            }
            this.$api.status.getBasicReport({
                type: type
            }).then(res => {
                this.lastMonthDay = res.info.lastMonthDay
                this.lastMonthTargetDay = res.info.lastMonthTargetDay
                this.monthDay = res.info.monthDay
                this.monthTargetDay = res.info.monthTargetDay
                if (this.type == 1) {
                    this.monthDataAll = Math.round(res.info.monthDataAll / 1000)
                    this.weekDataAll = Math.round(res.info.weekDataAll / 1000)
                    this.lastWeekAvgData = parseInt(res.info.lastWeekAvgData / 1000);
                    this.lastMonthAvgData = parseInt(res.info.lastMonthAvgData / 1000);
                    this.monthAvgData = parseInt(res.info.monthAvgData / 1000);
                    this.weekAvgData = parseInt(res.info.weekAvgData / 1000);
                    this.calCal(Math.round(this.weekDataAll / 10) * 10)
                } else if (this.type == 0) {
                    this.monthDataAll = res.info.monthDataAll
                    this.weekDataAll = res.info.weekDataAll
                    this.stepLaps = (this.userStep * this.weekDataAll / 100 / 400).toFixed(2);
                    this.lastWeekAvgData = parseInt(res.info.lastWeekAvgData);
                    this.lastMonthAvgData = parseInt(res.info.lastMonthAvgData);
                    this.monthAvgData = parseInt(res.info.monthAvgData);
                    this.weekAvgData = parseInt(res.info.weekAvgData);
                } else if (this.type == 2) {
                    this.monthDataAll = Math.round(res.info.monthDataAll / 60);
                    this.weekDataAll = Math.round(res.info.weekDataAll / 60);
                    this.stepLaps = (this.userStep * this.weekDataAll / 100 / 400).toFixed(2);
                    this.lastWeekAvgData = parseInt(res.info.lastWeekAvgData / 60);
                    this.lastMonthAvgData = parseInt(res.info.lastMonthAvgData / 60);
                    this.monthAvgData = parseInt(res.info.monthAvgData / 60);
                    this.weekAvgData = parseInt(res.info.weekAvgData / 60);
                }
                console.log(this.weekAvgData - this.lastWeekAvgData)
                if (this.weekAvgData - this.lastWeekAvgData > 0) {
                    this.weekSymbol = 0;
                } else if (this.weekAvgData - this.lastWeekAvgData < 0) {
                    this.weekSymbol = 1;
                } else {
                    this.weekSymbol = 2;
                }
                if (this.monthAvgData - this.lastMonthAvgData > 0) {
                    this.monthSymbol = 0;
                } else if (this.monthAvgData - this.lastMonthAvgData < 0) {
                    this.monthSymbol = 1;
                } else {
                    this.monthSymbol = 2;
                }
                if (this.monthTargetDay - this.lastMonthTargetDay > 0) {
                    this.daySymbol = 0;
                } else if (this.monthTargetDay - this.lastMonthTargetDay < 0) {
                    this.daySymbol = 1;
                } else {
                    this.daySymbol = 2;
                }
                let weekData = [];
                for (let i = 0; i < res.info.weekData.length; i++) {
                    if (res.info.weekData[i].value == 0) {
                        weekData.push({
                            date: res.info.weekData[i].date,
                            value: null
                        })
                    } else {
                        if (this.type == 1) {
                            weekData.push({
                                date: res.info.weekData[i].date,
                                value: res.info.weekData[i].value / 1000
                            })
                        } else {
                            weekData.push(res.info.weekData[i])
                        }

                    }
                }
                let lastWeekData = [];
                for (let i = 0; i < res.info.lastWeekData.length; i++) {
                    if (res.info.lastWeekData[i].value == 0) {
                        lastWeekData.push({
                            date: res.info.lastWeekData[i].date,
                            value: null
                        })
                    } else {
                        if (this.type == 1) {
                            lastWeekData.push({
                                date: res.info.lastWeekData[i].date,
                                value: res.info.lastWeekData[i].value / 1000
                            })
                        } else {
                            lastWeekData.push(res.info.lastWeekData[i])
                        }

                    }
                }
                this.$nextTick(() => {
                    this.drawDayChart('last-chart', lastWeekData, getSkin('--text-color-2'), getSkin('--text-color-1'));
                    let color1 = this.type == 0 ? getSkin('--chart-color-11') : this.type == 1 ? getSkin('--chart-color-4') : getSkin('--chart-color-2');
                    let color2 = this.type == 0 ? getSkin('--chart-color-8') : this.type == 1 ? getSkin('--chart-color-3') : getSkin('--chart-color-1');
                    this.drawDayChart('this-chart', weekData, color1, color2);
                })
            })
        },
        drawDayChart(id, odata, color1, color2) {
            let _this = this;
            let data = odata;
            let myChart = this.$echarts.init(document.getElementById(id), null, {renderer: 'svg'});
            myChart.setOption({
                grid: {
                    top: 15,
                    bottom: 15,
                    left: 0,
                    right: 0
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    data: ['1', '2', '3', '4', '5', '6', '7']
                },
                emphasis: {
                    disabled: true
                },
                yAxis: {
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        data: data,
                        type: 'bar',
                        lineStyle: {
                            width: 3
                        },
                        barWidth: 8,
                        itemStyle: {
                            normal: {
                                barBorderRadius: [15, 15, 0, 0],
                                color: color1
                            }
                        },
                        markLine: {
                            symbol: "none",
                            emphasis: {
                                disabled: true
                            },
                            data: [
                                {
                                    type: "average",
                                    symbol: "none",
                                    silent: false,
                                    lineStyle: {
                                        color: color2
                                    },
                                    label: {
                                        position: 'middle',
                                        fontFamily: 'D-D',
                                        fontSize: 16 * this.ratio,
                                        color: getSkin('--text-color-1'),
                                        formatter: function (e) {
                                            let value = e.value;
                                            if (_this.type == 2) {
                                                const minutes = Math.floor(value / 60);
                                                const seconds = Math.floor(value % 60);

                                                // 当秒数为0时只显示分钟
                                                if (minutes === 0) {
                                                    value = `${seconds} s`;
                                                } else if (seconds === 0){
                                                    value = `${minutes} min`;
                                                } else {
                                                    value = `${minutes} min ${seconds} s`;
                                                }
                                                return  value
                                            }
                                            return format(parseInt(e.value));
                                        }
                                    }
                                }
                            ]
                        }
                    }
                ]
            }, true);
        },
        format(num) {
            return format(num)
        },
        calCal(cal) {
            let receiveCal = cal % 350;
            this.bigFood.num = (cal - receiveCal) / 350;
            console.log('receiveCal', receiveCal)
            console.log('bigFood', this.bigFood)
            if (receiveCal > 0) {
                this.smallFood = this.foodCalories.find(food => food.cal == receiveCal);
            } else {
                this.smallFood = 0
            }
            if (cal > 350 && receiveCal > 0) {
                this.showAnd = true
            } else {
                this.showAnd = false
            }
        },
    }
}
</script>

<style scoped>
.card {
    margin-top: 4px;
    width: 100%;
}

.card-title {
    color: var(--text-color-3);
    font-size: 15px;
    float: left;
    line-height: 12px;
    margin-left: 15px;
}


.target-desc {
    font-size: 13px;
    color: var(--text-color-2);
    margin-left: 16px;
    margin-top: 15px;
    line-height: 18px;
    letter-spacing: 0.5px;
}
.ratio-title {
    font-size: 12px;
    border-radius: 5px 5px 5px 5px;
    margin-left: 10px;
    text-align: center;
    letter-spacing: 2px;
    padding: 4px 6px;
    line-height: 12px;
    display: table;
}

.ratio-title-step {
    color: var(--chart-color-8);
    border: 1px solid var(--chart-color-8);
}

.ratio-title-cal {
    color: var(--chart-color-3);
    border: 1px solid var(--chart-color-3);
}

.ratio-title-strength {
    color: var(--chart-color-1);
    border: 1px solid var(--chart-color-1);
}

.separate {
    height: 15px;
}

.card-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto 20px;
}

.card-title-line {
    height: 24px;
    width: 100%;
}

.card-title-line-en {
    height: 36px !important;
}

.day-average-box {
    width: 316px;
    height: 85px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.last-chart {
    width: 153px;
    height: 100%;
    display: inline-block;
}

.this-chart {
    width: 153px;
    height: 100%;
    display: inline-block;
}

.day-desc {
    font-size: 13px;
    color: var(--text-color-2);
    margin-left: 16px;
    padding-bottom: 16px;
    line-height: 18px;
    letter-spacing: 0.5px;
}

.current-month {
    width: 238px;
    height: 18px;
    border-radius: 9px 9px 9px 9px;
    margin-left: 16px;
}

.step-color {
    background: var(--chart-color-8);
}

.cal-color {
    background: var(--chart-color-3);
}

.strength-color {
    background: var(--chart-color-1);
}

.big-month {
    width: 307px !important;
}

.month-num {
    font-size: 16px;
    color: var(--text-color-1);
    margin-left: 16px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.last-month {
    width: 238px;
    height: 18px;
    background: #9DACB7;
    border-radius: 9px 9px 9px 9px;
    margin-left: 16px;
}

.current-month-text {
    font-size: 13px;
    color: #FFFFFF;
    margin-left: 7px;
    line-height: 18px;
}

.last-month-text {
    font-size: 13px;
    color: #000000;
    margin-left: 7px;
    line-height: 18px;
}

.reach-progress {
    width: 200px;
    margin-left: 16px;
    position: relative;
    display: inline-block;
}

/deep/ .van-progress {
    border-radius: 20px;
}

.reach-text {
    position: absolute;
    left: 0px;
    top: 0px;
}

.reach-num-text {
    font-size: 19px;
    color: var(--text-color-1);
}

.reach-num {
    font-size: 15px;
    color: var(--text-color-3);
    width: 100px;
    display: inline-block;
    margin-left: 20px;
    vertical-align: text-top;
}

.reach-line {
    display: flex;
    align-items: center;
    margin-top: 10px;
    height: 28px;
}

/deep/ .van-progress__pivot {
    display: none !important;
}

</style>


// WEBPACK FOOTER //
// src/views/status/19abstract.vue